<template>
	<div class="active-chats">
		<ul>
			<li v-for="chat in rooms" @click="openChat(chat.room)" v-if="typeof chat.type === 'string' && chat.type.trim() !== ''">
				<div class="text">{{determineChatName(chat)}}</div>
				<div class="count">
                    <template v-if="chat.type === 'kraemmerSale'">
                        <Handshake/>
                    </template>
                    <template v-else>
                        <User/>
                        <div class="amount">{{Object.keys(chat.currentParticipants).length}}</div>
                    </template>
				</div>
				<NotificationsCounter v-if="chat.unreadMessages > 0" :count="chat.unreadMessages" />
			</li>
		</ul>
	</div>
</template>

<script>
	import {mapState} from "vuex";
	import User from "@/assets/icons/user.svg"
	import Handshake from "@/assets/icons/handshake.svg"
	import NotificationsCounter from "@/components/chat/NotificationsCounter";
	export default {
		components: {NotificationsCounter, User, Handshake},
		computed: {
			...mapState('vorbasse', {
				rooms: 'rooms'
			}),
		},
		methods: {
			openChat(room){
				this.$vorbasseSocket.emit('open-room',room);
			},
			determineChatName(chat){
				if(chat.type === 'kraemmerSale')
				{
					const kraemmer = Object.keys(chat.participants).filter((key) => key !== chat.tokenId);
					return (kraemmer.length === 1) ? chat.participants[kraemmer[0]].displayName : 'Chat med kræmmer';
				}
				else
				{
					return (chat.name !== null && chat.name !== '') ? chat.name : 'Ikke navngivet'
				}
			}
		}
	};
</script>

<style scoped>

</style>
